import { STUDIO_SEARCH_PAGE_SIZE } from 'constants/app';
import { Store } from 'store/index';

const getSearchResultsFetched = (store: Store) => store.studioSearch.maxPage * STUDIO_SEARCH_PAGE_SIZE;

export default getSearchResultsFetched;
